import type { AttStatusPayload } from '../types';
import { useNativeTrackingConsent } from '~/composables/useNativeTrackingConsent';

/**
 * Recebe o veredito do ATT do app nativo e libera/bloqueia os pixels de
 * marketing na WebView. iOS: só libera com `granted`. Android: sempre libera
 * (chega como 'granted', sem ATT).
 */
export function handleAttStatus(payload: AttStatusPayload): void {
  const allowed = payload.platform !== 'ios' || payload.status === 'granted';

  useNativeTrackingConsent().setNativeConsent(allowed);
}
